let ExposureMode = {
    SET_EXPOSURE_MODE: 'SET_EXPOSURE_MODE',
};

export default ExposureMode;
